export default {
	state: { filters: [], affectedCustomers: 0, filterResponse: null },
	getters: {
		getMarketingFilters(state) {
			return state.filters;
		},
		getAffectedCustomers(state) {
			return state.affectedCustomers;
		},
		getFilterResponse(state) {
			return state.filterResponse;
		},
	},
	mutations: {
		setMarketingFilters(state, payload) {
			state.filters = payload.filters;
			state.affectedCustomers = payload.affectedCustomers;
			state.filterResponse = payload.filterResponse;
		},
		clearMarketingAds(state) {
			state.filters = [];
			state.affectedCustomers = 0;
			state.filterResponse = {};
		},
	},
};
